module.exports = __webpack_public_path__ + "static/scale-model-of-golden-history-park-in-lakewood-colorado-05b4d53842cfe60bcfed8b0b84e7d04b.png";